// directives/click-outside.js
export default {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (event.target.closest('.mention-dropdown')) {
        return;
      }
      // mce 관련 DOM(id 또는 class에 'mce' 포함)에서 클릭 시 무시
      const isMceTarget = event.target.closest('[id*="mce"],[class*="mce"]');
      if (isMceTarget) {
        return;
      }
      if (el === event.target || el.contains(event.target)) {
        return;
      }
      vnode.context[binding.expression](event);
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};
